import type { DynamicProduct, ProductsReferential } from 'models/productsReferential';

export type ProductsReferentialAction =
  | ProductsReferentialLoaded
  | ProductsReferentialLoadingFailed
  | ProductsReferentialRequested
  | DynamicProductsLoaded
  | DynamicProductsLoadingFailed
  | DynamicProductsRequested;

export function productsReferentialRequested() {
  return { type: 'PRODUCTS_REFERENTIAL_REQUESTED' as const };
}
export type ProductsReferentialRequested = ReturnType<typeof productsReferentialRequested>;

// ########################################################################################

export function productsReferentialLoaded(productsReferential: ProductsReferential) {
  return { type: 'PRODUCTS_REFERENTIAL_LOADED' as const, productsReferential };
}
export type ProductsReferentialLoaded = ReturnType<typeof productsReferentialLoaded>;

// ########################################################################################

export function productsReferentialLoadingFailed(errorMessage: string) {
  return { type: 'PRODUCTS_REFERENTIAL_LOADING_FAILED' as const, errorMessage };
}
export type ProductsReferentialLoadingFailed = ReturnType<typeof productsReferentialLoadingFailed>;

// ########################################################################################

export function dynamicProductsRequested() {
  return { type: 'DYNAMIC_PRODUCTS_REQUESTED' as const };
}
export type DynamicProductsRequested = ReturnType<typeof dynamicProductsRequested>;

// ########################################################################################

export function dynamicProductsLoaded(dynamicProducts: readonly DynamicProduct[]) {
  return { type: 'DYNAMIC_PRODUCTS_LOADED' as const, dynamicProducts };
}
export type DynamicProductsLoaded = ReturnType<typeof dynamicProductsLoaded>;

// ########################################################################################

export function dynamicProductsLoadingFailed(errorMessage: string) {
  return { type: 'DYNAMIC_PRODUCTS_LOADING_FAILED' as const, errorMessage };
}
export type DynamicProductsLoadingFailed = ReturnType<typeof dynamicProductsLoadingFailed>;
